import { render, staticRenderFns } from "./prospect-rider.vue?vue&type=template&id=7a5cecfc"
import script from "./prospect-rider.vue?vue&type=script&lang=js"
export * from "./prospect-rider.vue?vue&type=script&lang=js"
import style0 from "./prospect-rider.vue?vue&type=style&index=0&id=7a5cecfc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports